//Module Keys
let locales = {};

//Merge Views

//Main
import mainView from "../../views/main/lan/es";
locales = { ...locales, ...mainView };

//Fuel Card Modals

import editManageFuelCard from "../../views/fuelCardTab/modals/editManageFuelCard/lan/es";
locales = { ...locales, ...editManageFuelCard };

//Crew Modals
import createEditManageCrew from "../../views/crewTab/modals/createEditManageCrew/lan/es";
locales = { ...locales, ...createEditManageCrew };

import deleteManageCrew from "../../views/crewTab/modals/deleteManageCrew/lan/es";
locales = { ...locales, ...deleteManageCrew };

//KeyFob Modals
import createEditManageKeyFob from "../../views/keyFobsTab/modals/createEditManageKeyFob/lan/es";
locales = { ...locales, ...createEditManageKeyFob };

import deleteManageKeyFob from "../../views/keyFobsTab/modals/deleteManageKeyFob/lan/es";
locales = { ...locales, ...deleteManageKeyFob };

//Temperature Modals
import createEditManageTemperature from "../../views/temperatureTab/modals/createEditManageTemperature/lan/es"
locales = { ...locales, ...createEditManageTemperature };

import deleteManageTemperature from "../../views/temperatureTab/modals/deleteManageTemperature/lan/es"
locales = { ...locales, ...deleteManageTemperature };

//Equipment Modals
import createEditEquipment from "../../views/equipmentTab/modals/createEditManageEquipment/lan/es";
locales = { ...locales, ...createEditEquipment };

import deleteEquipment from "../../views/equipmentTab/modals/deleteManageEquipment/lan/es";
locales = { ...locales, ...deleteEquipment }; 

//Driver Status Modals
import createEditDriverStatus from "../../views/driverStatusTab/modals/createEditManageDriverStatus/lan/es";
locales = { ...locales, ...createEditDriverStatus };

import deleteDriverStatus from "../../views/driverStatusTab/modals/deleteManageDriverStatus/lan/es";
locales = { ...locales, ...deleteDriverStatus };

//Locations
import createEditLocation from "../../views/locationsTab/modals/createEditManageLocation/lan/es";
locales = { ...locales, ...createEditLocation };
import deleteLocation from "../../views/locationsTab/modals/deleteManageLocation/lan/es";
locales = { ...locales, ...deleteLocation };

//Camera Management
import editCameraManagementCamera from "../../views/cameraManagementTab/modals/editCameraManagementCamera/lan/es";
locales = { ...locales, ...editCameraManagementCamera };
import editCameraManagementPairing from "../../views/cameraManagementTab/modals/editCameraManagementPairing/lan/es";
locales = { ...locales, ...editCameraManagementPairing };

//Behavior Modals
import createEditManageBehavior from "../../views/behaviorTab/modals/create/lan/es";
locales = { ...locales, ...createEditManageBehavior };
import deleteManageBehavior from "../../views/behaviorTab/modals/delete/lan/es";
locales = { ...locales, ...deleteManageBehavior };

//Vehicle Status Modals
import createEditManageVehicleStatus from "../../views/vehicleStatusTab/modals/createEditManageVehicleStatus/lan/es";
locales = { ...locales, ...createEditManageVehicleStatus };
import deleteManageVehicleStatus from "../../views/vehicleStatusTab/modals/deleteManageVehicleStatus/lan/es";
locales = { ...locales, ...deleteManageVehicleStatus };

//Inputs Modals
import createEditManageInput from "../../views/inputsTab/modals/createEditManageInput/lan/es";
locales = { ...locales, ...createEditManageInput };

import deleteManageInput from "../../views/inputsTab/modals/deleteManageInput/lan/es";
locales = { ...locales, ...deleteManageInput };

//Assets tab
import assetTab from "../../views/assetTab/lan/es";
locales = { ...locales, ...assetTab };

//Asset Subtype
import assetSubtype from "../../views/assetSubtype/lan/es";
locales = { ...locales, ...assetSubtype };

//Work Order Status
import workOrderStatus from "../../views/workOrderStatus/lan/es";
locales = { ...locales, ...workOrderStatus };

//Work Order Type
import workOrderType from "../../views/workOrderType/lan/es";
locales = { ...locales, ...workOrderType };

export default locales;
